import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { analytics } from 'core/analytics';

import { BANNER_ACTIONS } from 'constants/analytics';
import Header from 'apps/components/header/header';
import { SectionBanner, Paragraph, Box } from 'components';
import Files from 'apps/files';
import Projects from 'apps/projects';

import { MainWrapper } from 'legacyComponents/styled/lib';
import RFQList from 'apps/rfq/rfqList';
import OrderList from 'apps/order/orderList';

import WorkspaceIndicator from './WorkspaceIndicator';

const Dashboard = observer(() => {
  return (
    <>
      <Header />
      <MainWrapper id='main-wrapper' marginBottom='4em'>
        <SectionBanner
          bannerId='introducing-make-button'
          imageSrc='/assets/banners/005.svg'
          title='Experience Collaborative Manufacturing.'
          buttonText='Get started '
          linkName='https://wikifactory.com/home/'
          eventCallback={() => {
            analytics.sendEvent(
              BANNER_ACTIONS.DASHBOARD,
              {},
              {
                ga: true,
              },
            );
          }}
          paddingTop='large'
          paddingBottom='xxlarge'
        >
          <Box>
            <Paragraph>
              <strong>Bring your innovations to life.</strong>
            </Paragraph>
            <Paragraph>
              Now you can <strong>share, iterate, prototype</strong> and
              <strong> manufacture</strong> your hardware products, completely
              online.
            </Paragraph>
            <Paragraph>
              <strong>
                From your first design review or prototype, to serial
                production. Kickstart your product development journey on
                Wikifactory.
              </strong>
            </Paragraph>
          </Box>
        </SectionBanner>
        <WorkspaceIndicator />
        <Files maxItems={3} />
        <Projects maxItems={3} />
        <RFQList maxItems={3} disableSortingFilteringFeatures />
        <OrderList maxItems={3} disableSortingFilteringFeatures />
      </MainWrapper>
    </>
  );
});

export default withNamespaces()(Dashboard);
